export default instance => {
    if(instance && instance.props && instance.props.app && instance.props.app.isTouchDevice) return true
    return false
}